import { IVideoContent } from "../../models/index";
import { removeContentGroupFromContent } from "../../services/index";
import { toastError, toastSuccess } from "../../utils/index";
import { Toast } from "primereact/toast";
import { useMutation, useQueryClient } from "react-query";

export const useRemoveContentGroupFromContent = (toast: React.RefObject<Toast>) => {
  const queryClient = useQueryClient();

  const { mutate, isLoading: removeContentGroupFromContentIsLoading } = useMutation(
    async (content: IVideoContent) => await removeContentGroupFromContent(content),
    {
      onSuccess: () => {
        queryClient.invalidateQueries("contentGroups");
        queryClient.invalidateQueries("content");
        toastSuccess(toast, "Content Removed");
      },
      onError: () => {
        toastError(toast, "Content not Removed");
      },
    }
  );

  return { mutate, removeContentGroupFromContentIsLoading };
};
